import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toogleTodaySandhayaAdd } from '../../../Utils/todaySandhayaSlice';

const TodaysSandhaya = () => {
    const dispatch = useDispatch();
    const [sandhayaId, setSandhayaId] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        handlePreviousData();
    }, []);

    const handlePreviousData = async () => {
        const data = await fetch('https://app-api.mokx.org/api/v1/today_sandhaya');
        const json = await data.json();
        setSandhayaId(json.data.todaySandhayas[0].todaySandhayaId);
    }

    console.log(sandhayaId);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            setLoading(true);
            await fetch(`https://app-api.mokx.org/api/v1/today_sandhaya/66ab463b7b43b76096f7ad7f`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "todaySandhayaId": sandhayaId
                }),
            });
            dispatch(toogleTodaySandhayaAdd());
            setSandhayaId("");
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    if(sandhayaId === "") {
        return;
    }

    return (
        <>
            <div tabIndex="-1" className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                <div className="relative w-full max-w-lg max-h-full mx-auto">
                    <div className="relative bg-white rounded-lg shadow">
                        <div className='flex items-center justify-between px-6 py-4'>
                            <h1 className='text-[#231F20] text-xl leading-8 font-figtree font-semibold'>Edit Today Sandhaya</h1>
                            <button type="button" className="text-[#999CA0]" onClick={() => dispatch(toogleTodaySandhayaAdd())}>
                                <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                            </button>
                        </div>
                        <div className='w-full h-[1px] bg-[#F2F2F2]'></div>
                        <div className='p-6 flex flex-col gap-6'>
                            <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                                <div className='flex flex-col'>
                                    <label htmlFor="sandhayaId" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Set Sandhaya Id<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            required
                                            type="text"
                                            name="sandhayaId"
                                            onChange={(e) => setSandhayaId(e.target.value)}
                                            value={sandhayaId}
                                            placeholder='Eg. 653a830105cd0bad13990662'
                                            className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                </div>
                                <div className='w-full h-[0.5px] bg-[#F2F2F2]'></div>
                                <div className='text-center'>
                                    <button type="submit" disabled={loading} className='w-[24%] bg-clip disabled:opacity-50 rounded-[8px] px-4 py-2 text-[#FFF] text-sm font-figtree font-semibold'>
                                        {!loading ? 'Submit' : 'Uploading'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full bg-[#282c3f]/[0.5] fixed top-0 left-0 z-[49]'></div>
        </>
    )
}

export default TodaysSandhaya;